import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/components/Layout.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { title: '登录' }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/Register.vue'),
    meta: { title: '代理注册' }
  },
  {
    path: '/',
    component: Layout,
    redirect: '/chat',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/Dashboard.vue'),
        meta: { title: '工作台', icon: 'el-icon-s-home' }
      },
      {
        path: 'agent/team',
        name: 'AgentTeam',
        component: () => import('@/views/Agent/Team.vue'),
        meta: { title: '我的团队', icon: 'el-icon-s-cooperation' }
      },
      {
        path: 'agent/team-member/:id',
        name: 'TeamMemberDetail',
        component: () => import('@/views/Agent/Team.vue'),
        meta: { title: '团队成员详情' }
      },
      {
        path: 'agent/customers',
        name: 'AgentCustomers',
        component: () => import('@/views/Agent/Customers.vue'),
        meta: { title: '客户管理', icon: 'el-icon-user-solid' }
      },
      {
        path: 'agent/commission',
        name: 'AgentCommission',
        component: () => import('@/views/Agent/Commission.vue'),
        meta: { title: '提成记录', icon: 'el-icon-s-finance' }
      },
      {
        path: 'agent/wallet',
        name: 'AgentWallet',
        component: () => import('@/views/Agent/Wallet.vue'),
        meta: { title: '我的钱包', icon: 'el-icon-money' }
      },
      {
        path: 'agent/sales-report',
        name: 'SalesReport',
        component: () => import('@/views/Agent/SalesReport.vue'),
        meta: { title: '销售报表', icon: 'el-icon-s-data' }
      },
      {
        path: 'order/list',
        name: 'OrderList',
        component: () => import('@/views/Order/OrderList.vue'),
        meta: { title: '订单管理', icon: 'el-icon-s-order' }
      },
      {
        path: 'order/create',
        name: 'OrderCreate',
        component: () => import('@/views/Order/OrderCreate.vue'),
        meta: { title: '创建订单', icon: 'el-icon-edit-outline' }
      },
      {
        path: 'order/detail/:id',
        name: 'OrderDetail',
        component: () => import('@/views/Order/OrderDetail.vue'),
        meta: { title: '订单详情' }
      },
      {
        path: 'shipping/pending',
        name: 'ShippingPending',
        component: () => import('@/views/Shipping/Pending.vue'),
        meta: { title: '待发货订单', icon: 'el-icon-truck' }
      },
      {
        path: 'shipping/warehouse',
        name: 'WarehouseManage',
        component: () => import('@/views/Shipping/Warehouse.vue'),
        meta: { title: '仓库管理', icon: 'el-icon-office-building' }
      },
      {
        path: 'notice/list',
        name: 'NoticeList',
        component: () => import('@/views/Notice/List.vue'),
        meta: { title: '公告消息', icon: 'el-icon-message-solid' }
      },
      {
        path: 'notice/create',
        name: 'NoticeCreate',
        component: () => import('@/views/Notice/Create.vue'),
        meta: { title: '发布公告', icon: 'el-icon-edit-outline' }
      },
      {
        path: 'product/list',
        name: 'ProductList',
        component: () => import('@/views/Product/List.vue'),
        meta: { title: '商品管理', icon: 'el-icon-s-goods' }
      },
      {
        path: 'account/list',
        name: 'AccountList',
        component: () => import('@/views/Account/List.vue'),
        meta: { title: '账号管理', icon: 'el-icon-s-custom' }
      },
      {
        path: 'change-password',
        name: 'ChangePassword',
        component: { template: '<div style="display:none"></div>' },
        meta: { title: '修改密码' }
      },
      {
        path: 'chat',
        name: 'ChatRoom',
        component: () => import('@/views/ChatRoom.vue'),
        meta: { title: '聊天室', icon: 'el-icon-chat-dot-round' }
      },
      {
        path: 'messages',
        name: 'MessageBoard',
        component: () => import('@/views/MessageBoard.vue'),
        meta: { title: '留言板', icon: 'el-icon-s-comment' }
      },
      {
        path: 'profile',
        name: 'Profile',
        component: () => import('@/views/Profile.vue'),
        meta: { title: '个人中心' }
      },
      {
        path: 'tool/list',
        name: 'ToolList',
        component: () => import('@/views/Tool/List.vue'),
        meta: { title: '装机软件', icon: 'el-icon-s-tools' }
      },
      {
        path: 'knowledge/list',
        name: 'KnowledgeList',
        component: () => import('@/views/Knowledge/List.vue'),
        meta: { title: '装机知识', icon: 'el-icon-notebook-2' }
      },
      {
        path: 'knowledge/create',
        name: 'KnowledgeCreate',
        component: () => import('@/views/Knowledge/Create.vue'),
        meta: { title: '发布装机知识', icon: 'el-icon-edit-outline' }
      },
      {
        path: 'knowledge/edit/:id',
        name: 'KnowledgeEdit',
        component: () => import('@/views/Knowledge/Create.vue'),
        meta: { title: '编辑装机知识' }
      },
      {
        path: 'knowledge/detail/:id',
        name: 'KnowledgeDetail',
        component: () => import('@/views/Knowledge/Detail.vue'),
        meta: { title: '装机知识详情' }
      },
      {
        path: 'material/list',
        name: 'MaterialList',
        component: () => import('@/views/Material/List.vue'),
        meta: { title: '商品素材', icon: 'el-icon-s-marketing' }
      },
      {
        path: 'material/create',
        name: 'MaterialCreate',
        component: () => import('@/views/Material/Create.vue'),
        meta: { title: '发布商品素材', icon: 'el-icon-edit-outline' }
      },
      {
        path: 'material/edit/:id',
        name: 'MaterialEdit',
        component: () => import('@/views/Material/Create.vue'),
        meta: { title: '编辑商品素材' }
      },
      {
        path: 'material/detail/:id',
        name: 'MaterialDetail',
        component: () => import('@/views/Material/Detail.vue'),
        meta: { title: '商品素材详情' }
      },
      {
        path: 'contact/index',
        name: 'ContactIndex',
        component: () => import('@/views/Contact/Index.vue'),
        meta: { title: '官方联络', icon: 'el-icon-phone-outline' }
      },
      {
        path: 'admin/sub-admins',
        name: 'SubAdminManage',
        component: () => import('@/views/Admin/SubAdmin.vue'),
        meta: { title: '下级管理员', icon: 'el-icon-s-management' }
      },
      {
        path: 'admin/agreement',
        name: 'AgreementEdit',
        component: () => import('@/views/Admin/AgreementEdit.vue'),
        meta: { title: '合作协议编辑', icon: 'el-icon-document' }
      },
      {
        path: 'admin/homepage-links',
        name: 'HomepageLinks',
        component: () => import('@/views/Admin/HomepageLinks.vue'),
        meta: { title: '首页链接管理', icon: 'el-icon-link' }
      },
      {
        path: 'admin/recharge-content',
        name: 'RechargeContent',
        component: () => import('@/views/Admin/RechargeContent.vue'),
        meta: { title: '充值内容设置', icon: 'el-icon-sell' }
      },
      {
        path: 'admin/referral-points-rules',
        name: 'ReferralPointsRules',
        component: () => import('@/views/Admin/ReferralPointsRules.vue'),
        meta: { title: '推广积分规则', icon: 'el-icon-s-cooperation' }
      },
      {
        path: 'admin/ads',
        name: 'AdsManage',
        component: () => import('@/views/Admin/Ads.vue'),
        meta: { title: '广告管理', icon: 'el-icon-s-flag' }
      },
      {
        path: 'admin/marquee-ads',
        name: 'MarqueeAdsManage',
        component: () => import('@/views/Admin/MarqueeAds.vue'),
        meta: { title: '滚动广告管理', icon: 'el-icon-s-flag' }
      },
      {
        path: 'admin/database-backup',
        name: 'DatabaseBackup',
        component: () => import('@/views/Admin/DatabaseBackup.vue'),
        meta: { title: '数据库备份', icon: 'el-icon-coin' }
      },
      {
        path: 'audit/logs',
        name: 'AuditLogs',
        component: () => import('@/views/Audit/Logs.vue'),
        meta: { title: '审计日志', icon: 'el-icon-s-check' }
      },
      {
        path: 'referral/index',
        name: 'ReferralIndex',
        component: () => import('@/views/Referral/Index.vue'),
        meta: { title: '推广链接', icon: 'el-icon-link' }
      },
      {
        path: 'points/index',
        name: 'PointsIndex',
        component: () => import('@/views/Points/Index.vue'),
        meta: { title: '积分管理', icon: 'el-icon-s-finance' }
      },
      {
        path: 'task/index',
        name: 'TaskIndex',
        component: () => import('@/views/Task/Index.vue'),
        meta: { title: '任务中心', icon: 'el-icon-medal' }
      },
      {
        path: 'followup/index',
        name: 'FollowUpIndex',
        component: () => import('@/views/FollowUp/Index.vue'),
        meta: { title: '客户跟进', icon: 'el-icon-phone-outline' }
      },
      {
        path: 'notify/index',
        name: 'NotifyIndex',
        component: () => import('@/views/Notify/Index.vue'),
        meta: { title: '消息中心', icon: 'el-icon-bell' }
      },
      {
        path: 'entrepreneurship/apply',
        name: 'EntrepreneurshipApply',
        component: () => import('@/views/Entrepreneurship/Apply.vue'),
        meta: { title: '提交新申请', icon: 'el-icon-edit-outline' }
      },
      {
        path: 'entrepreneurship/my-applications',
        name: 'EntrepreneurshipMyApplications',
        component: () => import('@/views/Entrepreneurship/MyApplications.vue'),
        meta: { title: '创业扶持', icon: 'el-icon-s-promotion' }
      },
      {
        path: 'admin/entrepreneurship-list',
        name: 'AdminEntrepreneurshipList',
        component: () => import('@/views/Admin/EntrepreneurshipList.vue'),
        meta: { title: '创业扶持申请列表', icon: 'el-icon-s-management' }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: '/',
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')

  // 登录和注册页面免登录访问
  if (to.path === '/login' || to.path === '/register') {
    if (token && to.path === '/login') {
      next('/chat')
      return
    }
    next()
    return
  }

  if (!token) {
    next('/login')
    return
  }

  // 角色权限检查
  let user = {}
  try {
    user = JSON.parse(localStorage.getItem('user') || '{}')
  } catch (_) {
    user = {}
  }
  const role = user.role || ''

  // 管理员专属页面前缀
  const adminPrefixes = ['/admin/', '/audit/', '/account/',
    '/knowledge/create', '/knowledge/edit',
    '/material/create', '/material/edit']
  const isAdminPath = adminPrefixes.some(p => to.path.startsWith(p))
  if (isAdminPath && role !== 'admin') {
    next('/dashboard')
    return
  }

  // 代理及以上才能访问的页面
  const agentPrefixes = ['/agent/', '/product/list',
    '/notice/create', '/tool/list',
    '/knowledge/', '/material/', '/contact/',
    '/referral/', '/points/', '/task/', '/followup/',
    '/entrepreneurship/']
  const agentRoles = ['admin', 'province', 'city', 'county', 'town']
  const isAgentPath = agentPrefixes.some(p => to.path.startsWith(p))
  if (isAgentPath && !agentRoles.includes(role)) {
    next('/dashboard')
    return
  }

  // 仓库管理仅 admin + province
  if (to.path === '/shipping/warehouse' && !['admin', 'province'].includes(role)) {
    next('/dashboard')
    return
  }

  // 远程装机/上门装机（town角色）首次登录强制改密，禁止访问其他页面
  if (role === 'town' && user.is_first_login && to.path !== '/chat' && to.path !== '/profile') {
    next('/chat')
    return
  }

  next()
})

export default router
